var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.15 4.55855C11.15 6.52389 9.73971 8.1171 8.00001 8.1171C6.26031 8.1171 4.85001 6.52389 4.85001 4.55855C4.85001 2.59322 6.26031 1 8.00001 1C9.73971 1 11.15 2.59322 11.15 4.55855Z",
    fill: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3 13.4549C14.3 15.6168 11.0928 14.8784 8.00001 14.8784C4.90722 14.8784 1.70001 15.6168 1.70001 13.4549C1.70001 11.2931 4.90722 9.54052 8.00001 9.54052C11.0928 9.54052 14.3 11.2931 14.3 13.4549Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.f2fb3f618eaf4f42b30ac736ebcaeb82.svg";
export { ForwardRef as ReactComponent };